"use client";
import { FC, useEffect } from "react";
import { usePathname } from "next/navigation";
import { endPageTransition } from "@/utils/pageLoader.utils";

interface RootTemplateProps {
  children: React.ReactNode;
}

const RootTemplate: FC<RootTemplateProps> = ({ children }) => {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname !== undefined) {
      endPageTransition();
    }
  }, [pathname]);

  return children;
};

export default RootTemplate;
